import { notesAndImageValidationValues } from '../constants'

export const additionalContentValues = [
  {
    value: notesAndImageValidationValues.required,
    label: 'Obligatorio',
  },
  {
    value: notesAndImageValidationValues.optional,
    label: 'Opcional',
  },
]
